import { UserService } from "@/api/service-proxies";
export const userService = new UserService();
